import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionFigureCaption as r } from "../types/HostActionFigure.mjs";
import { HostActionTargetKind as i } from "../types/HostActionTarget.mjs";
import { getBookingSettlementCurrency as a } from "@maat/api-booking/types";
import { parseAmount as o } from "@maat/currency";
//#region src/mappers/toBookingRequestActions.ts
var s = (s) => s.map((s) => {
	let c = o(s.host_payout);
	return {
		id: `${e.BookingRequest}:${s.id}`,
		type: e.BookingRequest,
		intent: t.Opportunity,
		imageUrl: s.metadata?.cover_image_url,
		avatarName: s.metadata?.guest_name,
		params: { guest: s.metadata?.guest_name },
		object: s.metadata?.listing_title,
		facets: [{
			kind: n.Stay,
			checkIn: s.check_in,
			checkOut: s.check_out
		}, {
			kind: n.Guests,
			count: s.guests
		}],
		figure: c === void 0 ? void 0 : {
			amount: c,
			currency: a(s),
			caption: r.YouEarn
		},
		createdAt: s.created_at,
		weight: c ?? 0,
		target: {
			kind: i.BookingDetail,
			id: s.id
		}
	};
});
//#endregion
export { s as toBookingRequestActions };
